import NorthEastOutlinedIcon from '@mui/icons-material/NorthEastOutlined';
import { Stack, Grid, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  getCurrentWorkspace,
  IJob,
  IJobBoard,
  IJobPostAtJobTargetDTO,
  postJobToJobTarget,
  updateWorkspace,
} from 'wisestep-api';
import { WsButton, WsList } from 'wisestep-base';

import { ActivateFeature } from '../../../../../components/ActivateFeature';
import JobTarget from '../../../../../images/jobBoardsIcons/JobTarget.png';
import { useNotificationStore } from '../../../../../utils/NotificationStore';

export interface IJobTargetProps {
  job: IJob;
}
const PostOnJobTarget = ({ job }: IJobTargetProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const [currentWorkSpace, setCurrentWorkSpace] = useState<any>();
  const listarray = [
    'Access to 25000+ Job Boards from every industry and function',
    'Access to popular, niche, collegiate, state job banks, diversity sites, etc.',
    ' Discounted prices & Job boards recommendations',
  ];

  useEffect(() => {
    const setWorkSpace = async () => {
      const workspaceObj = await getCurrentWorkspace();
      setCurrentWorkSpace(workspaceObj.data);
    };

    setWorkSpace();
  }, []);

  const buildRecruiterJobTargetJobBoardAccount = () => {
    const jobBoard: IJobBoard = {
      username: '',
      userFirstName: '',
      userLastName: '',
      userTitle: '',
      jobBoardName: 'JobTarget',
      userCompanyId: currentWorkSpace?.companyIdAtJobTarget ?? '',
      workspaceId: currentWorkSpace?.id ?? '',
      workspaceName: currentWorkSpace?.name ?? '',
      id: '',
      jobBoardType: '',
      password: '',
      jobBoardSettings: '',
      autoRefresh: '',
      jobDuration: '',
      careerAdNetwork: '',
      diceGroupId: '',
      createdBy: '',
      createdOn: new Date(),
      jobBoardSharedTeamDetails: [],
      jobBoardSharedUsers: [],
      isJobBoardAdminUser: false,
      userIdAtJobBoard: '',
    };

    return jobBoard;
  };

  const postJobOnJobTarget = async () => {
    const jobTargetDTO: IJobPostAtJobTargetDTO = {
      jobId: job.id ?? '',
      userName: '',
      jobBoardAccount: buildRecruiterJobTargetJobBoardAccount(),
    };
    try {
      const jobTargetResp = await postJobToJobTarget(jobTargetDTO);
      if (jobTargetResp != null && jobTargetResp.data.jobTargetJobPostUrl) {
        setNotification({ message: 'Posted the job to selected Job board.', type: 'success' });
        window.open(jobTargetResp.data.jobTargetMarketplaceIframe, '_blank');
      }
    } catch (e) {
      setNotification({
        message: 'Failed to post on selected Job Board. Please contact administrator.',
        type: 'error',
      });
    }
  };

  const publishToJobTarget = async () => {
    if (!currentWorkSpace?.companyNameAtJobTarget) {
      setCurrentWorkSpace({
        ...currentWorkSpace,
        companyNameAtJobTarget: currentWorkSpace?.name ?? '',
      });

      const workspaceUpdateResp = await updateWorkspace(currentWorkSpace);
      setCurrentWorkSpace(workspaceUpdateResp.data);
      postJobOnJobTarget();
    } else {
      postJobOnJobTarget();
    }
  };

  return (
    <Grid>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Grid pb={1}>
          <img src={JobTarget} alt="JobTarget" />
        </Grid>
        <Stack spacing={8}>
          <WsList title="Job Target" listArray={listarray} />
          <ActivateFeature feature="JS_MARKET_PLACE_APPS">
            <WsButton
              size="large"
              disabled={true}
              onClick={publishToJobTarget}
              endIcon={<NorthEastOutlinedIcon />}
            >
              Publish on JobTarget
            </WsButton>
          </ActivateFeature>
        </Stack>
      </Paper>
    </Grid>
  );
};

export default PostOnJobTarget;
